import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { Checkbox, palettes } from '@indigo-ag/component-module';

const ValidateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 1rem;
  width: 100%;
`;

interface ValidatedCellProps {
  validated: boolean;
  editable?: boolean;
}

const ValidatedCell: React.FC<ValidatedCellProps> = ({ validated, editable = false }) => {
  const iconType = validated ? faCheck : faTimes;
  const color = validated ? palettes.brand.green.base : palettes.brand.red.base;
  return (
    <ValidateWrapper>
      {editable ? (
        <Checkbox checked={validated} onChange={() => {}} />
      ) : (
        <FontAwesomeIcon icon={iconType} color={color} />
      )}
    </ValidateWrapper>
  );
};

export default ValidatedCell;
